import React from 'react';
import { getClubConceptDisplay } from '../../../../utils/clubs';

import styles from '../../../../pages/ClubProfiles/club.scss';

const Info = (props) => {
    let { url } = props;
    if (url && !url.toLowerCase().match('^\\w+://.*')) {
        url = `http://${url}`;
    }

    return (
        <div>
            {url && (
                <React.Fragment>
                    <h6>Info</h6>
                    <div className={`row ${styles.clubInfo}`}>
                        <div className="col-12">
                            <a className={`${styles.action}`} href={url} target="_blank" rel="noopener noreferrer">
                                <i className={`${styles.actionIcon} uts uts-arrow-circle`} />
                                <span className={`${styles.actionName}`}>
                                    {getClubConceptDisplay(props.tierType.name)}
                                </span>
                            </a>
                        </div>
                    </div>
                </React.Fragment>
            )}
        </div>
    );
};

export default Info;
